import Link from 'next/link';
import Image from 'next/image';
import clsx from 'clsx';
import { ArrowRight } from '@/components/pages/icons';
import type { DesktopSubMenuProps, SubmenuItem } from './type';

function SubmenuLink({ item }: { item: SubmenuItem }) {
  return (
    <li>
      <Link
        className="text-brand-text-button text-xl leading-[130%] tracking-[-0.4px] hover:brightness-90"
        href={item.url}
        prefetch={false}
      >
        {item.label}
      </Link>
    </li>
  );
}

export function DesktopSubMenu({ menu }: DesktopSubMenuProps) {
  const { sections, image, imageAlt = '', footer } = menu;

  return (
    <nav className="hidden group-open:@lg:grid grid-cols-4 w-full border-t border-t-[#E5E7EB]">
      {image && (
        <Image
          src={image}
          className="h-full object-cover"
          alt={imageAlt}
          width={302}
          height={264}
        />
      )}
      <div className="col-span-3 pt-6 px-6">
        {/* Divider only *between* sections; the bottom border only exists to
            separate the list from a footer (practice areas), never trailing. */}
        <div className={clsx('flex flex-col', footer && 'border-b border-b-[#E5E7EB]')}>
          {sections.map((section, index) => (
            <div
              key={section.title ?? `section-${index}`}
              className={clsx('py-6 first:pt-0', index > 0 && 'border-t border-t-[#E5E7EB]')}
            >
              {section.title && (
                <h3 className="text-sm font-medium tracking-[0.21px] text-gray-light mb-3">
                  {section.title}
                </h3>
              )}
              <ul className="grid grid-cols-4 gap-4">
                {section.items.map((item) => (
                  <SubmenuLink key={`desktop-submenu-${item.url}`} item={item} />
                ))}
              </ul>
            </div>
          ))}
        </div>
        {footer && (
          <Link
            href={footer.href}
            prefetch={false}
            className="flex items-center gap-2 py-6 text-brand-button hover:text-brand-button-hover transition-colors font-semibold text-base"
          >
            <span className="underline">{footer.label} </span>
            <ArrowRight className="w-4 h-4" />
          </Link>
        )}
      </div>
    </nav>
  );
}
